import React from 'react';
import { StyleSheet } from 'react-native';
import { GridList, DNABox, DNACheckbox, util, DNAText } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { useAppSettings } from 'src/state/context/AppSettings';
import { GridListSingleColumnHeader, ListFieldConfig } from 'src/components/DNA';
import { useSort } from 'src/components/DNA/hooks/useSort';

const S = StyleSheet.create({
  headerContainer: {
    backgroundColor: colors['color-ui2-neutral-50'],
    maxHeight: 40,
    overflow: 'hidden',
    borderRadius: 8,
    paddingHorizontal: 8,
    marginBottom: 10,
  },
  cellStyle: {
    paddingVertical: 12,
  },
  fieldCellContainer: {
    paddingLeft: 12,
  },
  MobileHeader: {
    backgroundColor: colors['color-gray-10'],
    maxHeight: 49,
    borderRadius: 0,
    marginBottom: 0,
  },
  flex: {
    flex: 1,
  },
  selectAllCheckbox: {
    margin: 6,
  },
})

interface GridListColumnHeaderRowProps {
  fieldConfigs: ListFieldConfig[],
  selectEnabled?: boolean,
  allDocumentSelected?: boolean,
  selectAllDocuments?: () => void,
}

const GridListColumnHeaderRow: React.FC<GridListColumnHeaderRowProps> = React.memo((props) => {
  const { fieldConfigs, selectEnabled, allDocumentSelected, selectAllDocuments } = props;
  const { sorts, toggleSort } = useSort();
  const { deviceMode } = useAppSettings();
  const isTablet = deviceMode === 'tablet';

  return (
    <GridList.Header
      style={util.mergeStyles(undefined, S.headerContainer, [S.MobileHeader, isTablet])}
      testID="documentlist-header"
    >
      {
        fieldConfigs.map(field => {
          if (field.fieldType === 'ACTION_MENU' && selectEnabled) {
            return (
              <GridList.Col
                key={field.fieldLabel}
                testID="documentlist-header-col-actionmenu"
              >
                <DNABox spacing="sm" alignY="center">
                  <DNACheckbox
                    context="altBg"
                    style={[S.selectAllCheckbox, { paddingLeft: isTablet ? 20 : 5 }]}
                    checked={allDocumentSelected}
                    onChange={selectAllDocuments}
                  />
                  <DNAText>{''}</DNAText>
                </DNABox>
              </GridList.Col>
            )
          } else {
            const isActionMenuField = field.fieldType === 'ACTION_MENU';
            const isThumbnailField = field.fieldName === 'thumbnail' && field.fieldType === 'MODEL';
            const finalCellStyle = util.mergeStyles(
              undefined,
              S.cellStyle,
              [S.fieldCellContainer, (!isActionMenuField && !isThumbnailField)],
            )
            return (
              <GridListSingleColumnHeader
                key={field.fieldName}
                field={field}
                style={finalCellStyle}
                toggleSort={toggleSort}
                sortDir={sorts?.[field.fieldName]?.dir}
                testID={`documentlist-header-col-${field.fieldName}`}
              />
            )
          }
        },
        )
      }
    </GridList.Header>
  )
})

export default GridListColumnHeaderRow;
